import { addToast, removeToast } from './toast-service';

// toast 是全局单例，计时与状态都收敛在 toast-service，这里只透传引用，
// 保证返回值在组件生命周期内恒等，不会让调用方的 useCallback 依赖反复失效
const toastApi = { add: addToast, remove: removeToast };

export function useToast() {
  return toastApi;
}
